import {Property} from "@/entities/questionaire/Property";

export class Group {
    id: number;
    name: string = "";
    properties: Property[] = [];

    constructor(id: number, name: string, properties: Property[]) {
        this.id = id;
        this.name = name;
        this.properties = properties;
    }

    static createGroup(obj: any): Group {
        let properties = obj.properties.map((x: any) => Property.createProperty(x));
        return new Group(obj.id, obj.name, properties);
    }

    toOpinionModel(): any {
        const result: any = Object.assign({}, this);
        result.properties = this.properties.map(x => x.toOpinionModel());
        return result;
    }
}
